import React from 'react';
import OwnershipBasedCostingForm from '../../../../components/costing/ownership-based-costing';
import HeaderTitle from '../../../../components/typography/header-title';

export default function OwnershipBasedCosting() {
    return (
        <>
            <HeaderTitle
                title={'Ownership-based Costing'}
                subtitle={
                    'Here you can see costs for resources owned by you.'
                }
            />
            <OwnershipBasedCostingForm />
        </>
    );
}
